import { TAG_CODES } from "../../tag.config"

const GOM_TRAFFIC_EVOLUTION = {
    type: 'path',
    tagCode: TAG_CODES.ROAD,
    withText: true,
    defaultText: 'Evolution',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M178 52H285M240 60H250M257 60 267 60M273 60 283 60`,
}

export default GOM_TRAFFIC_EVOLUTION